import React from 'react';
import { Link } from 'react-router-dom';
import FeaturedGames from '../FeaturedGames/FeaturedGames';
import StatsCards from '../StatsCards/StatsCards';

const Dashboard: React.FC = () => {
  return (
    <>
      <section className="featured">
        <div className="section-header">
          <h2>Featured</h2>
          <div className="header-divider"></div>
          <Link to="/games" className="view-all">
            View All
            <i className="lni lni-chevron-right"></i>
          </Link>
        </div>
        <FeaturedGames />
      </section>

      <section className="top-players">
        <div className="section-header">
          <h2>Statistics</h2>
          <div className="header-divider"></div>
          <Link to="/statistics" className="view-all">
            View All
            <i className="lni lni-chevron-right"></i>
          </Link>
        </div>
        <StatsCards />
      </section>
    </>
  );
};

export default Dashboard; 